module.exports = __webpack_public_path__ + "media/photo/footer-logo-2d9290a0.png";